// extracted by mini-css-extract-plugin
export default {"container":"ProjectSummary_container__h9j65","title":"ProjectSummary_title__gVkxR","linksContainer":"ProjectSummary_linksContainer__iYPPc","summary":"ProjectSummary_summary__ytFIo"};